import { BaseEditViewStore} from 'core/stores';
import { NikoFacilityOrderPatientTemplateNoteModalForm } from 'application/niko-facility-order/forms';

class NikoFacilityOrderPatientTemplateNoteModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const patientTemplate = componentProps.modalParams.data.patientTemplate;
        super(rootStore, {
            name: 'niko-facility-order-patient-template-note-modal',
            Form: NikoFacilityOrderPatientTemplateNoteModalForm,
            id: patientTemplate.id,
            actions: () => {
                return {
                    get: async() =>{
                        return patientTemplate;
                    },
                }
            },
            FormClass: NikoFacilityOrderPatientTemplateNoteModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
    }
}

export default NikoFacilityOrderPatientTemplateNoteModalStore;
